<template>
  <div v-if="value?.length">
    <div
      v-for="(funderName, index) in value"
      :key="index"
      class="my-6 w-40"
      :class="textClass"
      v-tooltipable
    >
      {{ funderName }}
    </div>
  </div>
  <div v-else>-</div>
</template>
<script lang="ts" setup>
const { value, textClass = "break-normal" } = defineProps<{
  value?: string[];
  textClass: string;
}>();
</script>
